import React, {useEffect, useState} from "react";
import "./Prepay.scss";
import {Button, Col, Form, Row, Space, Table, notification} from "antd";
import TableInputAdd from "components/common/TableInputAdd/TableInputAdd";
import {ExcelSVG} from "assets";
import Icon from "assets/icons";
import {columnsPrepay, inputField} from "./Prepay.config";
import ModalAddPrepay from "./ModalAddPrepay/ModalAddPrepay";
import {payService} from "api";
import dayjs from "dayjs";
import moment from "moment";
import {useAppDispatch, useAppSelector} from "redux/hooks";
import {InputFields, ListActionButton} from "components/common";
import {setCallApi, setIdSecond} from "redux/reducer/reduxCommon";
import ModalUpdate from "./ModalUpdate/ModalUpdate";
import Notification from "components/common/notification/notification";
import ModalPrint from "./ModalPrint/ModalPrint";
import ModalPrintBH from "./ModalPrintPrepayBH/ModalPrintPrepayBH";
import ModalPrintPPT from "./ModalPrintPPT/ModalPrintPPT";
import ModalOptionPrint from "./ModalOptionPrint/ModalOptionPrint";
import {FORMAT_TIME} from "types/enums";
import {checkAdmin} from "helper/common";

const Prepay: React.FC = () => {
  const [isShowModal, setIsShowModal] = useState(false);
  const [isShowModalBH, setIsShowModalBH] = useState(false);
  const [isShowModalUpdate, setIsShowModalUpdate] = useState(false);
  const [data, setData] = useState([]);
  const [loadingTable, setLoadingTable] = useState(true);
  const [totalPage, setTotalPage] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [form] = Form.useForm();
  const [dataPrepay, setDataPrepay] = useState([]);
  const disPath = useAppDispatch();
  const idData = useAppSelector(state => state.reduxCommon.id);
  const callApi = useAppSelector(state => state.reduxCommon.callApi);
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const [isShowModalPrint, setIsShowModalPrint] = useState(false);
  const [isShowModalPrintOption, setIsShowModalPrintOption] = useState(false);
  const [listId, setListId] = useState([]);
  const [dataPPT, setDataPPT] = useState([]);
  const [listIdBh, setListIdBh] = useState([]);
  const [record, setRecord] = useState(null);
  const isAdmin = checkAdmin();
  useEffect(() => {
    getDataTable();
  }, [currentPage, idData, callApi]);

  useEffect(() => {
    form.setFieldsValue({
      soTienGiaoDich: 0,
      idHinhThucThanhToan: "",
      maGiaoDich: 0,
    });
  }, [idData]);

  const getDataTable = async () => {
    try {
      const response = await payService
        .getListPrepayId(idData, currentPage)
        .then(res => {
          // console.log("response tạm ứng", res);
          // notification.success({ message: "Lấy dữ liệu thành công" });
          const newData = res.data.data.map(item => ({
            ...item,
            key: item.id,
            soPhieu: item.soPhieu,
            reason: item.lyDoTamUng,
            nguoiDeNghi: item.nguoiLap,
            khoaNB: item.khoaNguoiBenh,
            ngayDeNghi: item.ngayDeNghi,
            ngayDuyet: item.ngayDeNghi
              ? dayjs(item.ngayDeNghi).format(FORMAT_TIME.dateTime)
              : "",
            soTien: item.soTienTamUng,
            hinhThucTT: item.idHinhThucThanhToan,
            status: item.idTrangThaiTamUng,
          }));
          setData(newData);
          setLoadingTable(false);
          setTotalPage(res.data.total);
        });
    } catch (error) {
      Notification("error", "Đã có lỗi xảy ra khi lấy dữ liệu tạm ứng");
    }
  };

  useEffect(() => {
    getDetailPay();
  }, [idData, callApi]);

  const getDetailPay = async () => {
    try {
      const response = await payService
        .getListDetailPrepay(idData)
        .then(res => {
          // console.log("res chi tiet thong ke thanh toan", res);
          form.setFieldValue("tongTienNguoiBenhTamUng", res.data.data);
        });
    } catch (error) {
      Notification(
        "error",
        "Đã có lỗi xảy ra khi lấy chi tiết thống kê thanh toán"
      );
    }
  };

  const handlePaginationChangeList = page => {
    setCurrentPage(page);
  };

  columnsPrepay.map(e => {
    if (e.key == "action") {
      e.render = (_, record, index) => {
        return (
          <ListActionButton
            deleteFunction={isAdmin ? () => handleOnDelete(record) : undefined}
            editFunction={() => handleOnEdit(record)}
          ></ListActionButton>
        );
      };
    }
  });

  const handleOnDelete = async record => {
    if (record.status == 1) {
      Notification("error", "Không thể thực hiện tác vụ");
      return;
    } else {
      try {
        const response = await payService.deletePrepay(record.key).then(res => {
          // console.log('res xoá tạm ứng', res);
          // Notification("error", "Đã có lỗi xảy ra khi l");
          disPath(setCallApi());
        });
      } catch (error) {
        Notification("error", "Đã có lỗi xảy ra khi xoá");
      }
    }
  };

  const handleOnEdit = record => {
    if (record.status == 1) {
      Notification("error", "Không thể thực hiện tác vụ");
      return;
    } else {
      setRecord(record);
      setIsShowModalUpdate(true);
      disPath(setIdSecond(record.key));
    }
  };

  const paginationConfig = {
    current: currentPage,
    total: totalPage,
    onChange: handlePaginationChangeList,
  };

  const showModal = () => {
    setIsShowModal(true);
  };

  const handleOk = () => {
    setIsShowModal(false);
  };

  const handleCancel = () => {
    setIsShowModal(false);
  };

  const showModalBH = () => {
    if (!listIdBh || !listIdBh.length) {
      Notification("warning", "Vui lòng chọn phiếu cần in");
      return;
    }
    setIsShowModalBH(true);
  };

  const handleOkBH = () => {
    setIsShowModalBH(false);
  };

  const handleCancelBH = () => {
    setIsShowModalBH(false);
  };

  const rowSelection = {
    onChange: (selectedRowKeys: React.Key[], selectedRows: any[]) => {
      // console.log(
      //   `selectedRowKeys:`, selectedRowKeys,
      //   "selectedRows: ",
      //   selectedRows
      // );
      setSelectedRowKeys(selectedRowKeys);
      const selectedRowStatuses = selectedRows.filter(row => row.status == 0);
      // const listId =
      const filteredArray = data.filter(item =>
        selectedRowKeys.includes(item.id)
      );
      setDataPrepay(selectedRowStatuses);
      setDataPPT(filteredArray);
      setListId(selectedRowKeys);
      setListIdBh(selectedRowKeys);
    },
    getCheckboxProps: (record: any) => ({
      name: record.name,
    }),
  };

  useEffect(() => {
    const filteredArray = data.filter(item =>
      selectedRowKeys.includes(item.id)
    );
    setDataPPT(filteredArray);
  }, [data, idData, callApi]);

  useEffect(() => {
    setListId([]);
    setListIdBh([]);
    setSelectedRowKeys([]);
  }, [idData]);

  const handleOnSubmit = async data => {
    // console.log('data', dataPrepay);
    if (!dataPrepay || !dataPrepay.length) {
      return;
    } else {
      const arrayData = dataPrepay.map(item => item.key);
      const dataSucces: any = {
        list_id: arrayData,
      };
      dataSucces.idHinhThucThanhToan = form.getFieldValue(
        "idHinhThucThanhToan"
      );
      dataSucces.maGiaoDich = form.getFieldValue("maGiaoDich");
      dataSucces.soTienGiaoDich = form.getFieldValue("soTienGiaoDich");
      // console.log('data duyet tam ung', dataSucces);
      await submitPrepayAction(dataSucces);
      setSelectedRowKeys([]);
      setDataPrepay([]);
      disPath(setCallApi());
    }
  };

  const submitPrepayAction = async data => {
    try {
      const response = await payService.submitPrepay(data);
      // notification.success({ message: "Thao tác thành công" });
    } catch (error) {
      Notification("error", "Đã có lỗi xảy ra khi duyệt");
    }
  };

  const handleOkUpdate = () => {
    setIsShowModalUpdate(false);
  };

  const handleCancelUpdate = () => {
    setIsShowModalUpdate(false);
  };

  const onFinishFail = error => {};

  const showModalPrintOption = () => {
    if (!listId || !listId.length) {
      Notification("warning", "Vui lòng chọn phiếu cần in");
      return;
    }
    setIsShowModalPrintOption(true);
  };

  const handleOpenOption = () => {
    setIsShowModalPrintOption(false);
  };

  const handleCancelPrintOption = () => {
    setIsShowModalPrintOption(false);
  };

  const showModalPrint = () => {
    if (!listId || !listId.length) {
      Notification("warning", "Vui lòng chọn phiếu cần in");
      return;
    }
    setIsShowModalPrint(true);
  };

  const handleOpen = () => {
    setIsShowModalPrint(false);
  };

  const handleCancelPrint = () => {
    setIsShowModalPrint(false);
  };

  return (
    <div className="tab-cancel-pay-container">
      <Space direction="vertical" size={"middle"} style={{width: "100%"}}>
        <Form
          form={form}
          onFinishFailed={onFinishFail}
          onFinish={handleOnSubmit}
          initialValues={{remember: true}}
          autoComplete="off"
        >
          <Row justify={"end"} align={"middle"} gutter={[16, 8]}>
            <Col>
              <Space wrap>
                <Button
                  className="btn-sub"
                  icon={<Icon.printer />}
                  onClick={showModalPrintOption}
                >
                  In phiếu phụ thu
                </Button>
                <Button
                  className="btn-sub"
                  icon={<Icon.printer />}
                  onClick={showModalPrint}
                >
                  In tạm ứng
                </Button>
                <Button
                  className="btn-sub"
                  icon={<Icon.add />}
                  onClick={showModal}
                >
                  Thêm tạm ứng
                </Button>
                <Button
                  className="btn-sub"
                  icon={<Icon.printer />}
                  onClick={showModalBH}
                >
                  In tạm ứng BH
                </Button>
              </Space>
            </Col>
          </Row>
          <Row style={{marginTop: "16px"}} gutter={[16, 8]}>
            <InputFields data={inputField} />
          </Row>
        </Form>

        <Row gutter={[16, 8]}>
          <Col span={24}>
            <Form component={false}>
              <Table
                bordered
                dataSource={data}
                columns={columnsPrepay}
                pagination={paginationConfig}
                loading={loadingTable}
                rowSelection={{
                  ...rowSelection,
                }}
              />
            </Form>
          </Col>
        </Row>
      </Space>
      <ModalAddPrepay
        isShowModal={isShowModal}
        handleOk={handleOk}
        handleCancel={handleCancel}
      />
      <ModalPrintBH
        isShowModal={isShowModalBH}
        handleOk={handleOkBH}
        handleCancel={handleCancelBH}
        listId={listIdBh}
      />
      <ModalUpdate
        isShowModal={isShowModalUpdate}
        handleOk={handleOkUpdate}
        handleCancel={handleCancelUpdate}
        // data={record}
      />
      <ModalPrint
        isShowModal={isShowModalPrint}
        handleOk={handleOpen}
        handleCancel={handleCancelPrint}
        listId={listId}
      />
      <ModalOptionPrint
        isShowModal={isShowModalPrintOption}
        handleOk={handleOpenOption}
        handleCancel={handleCancelPrintOption}
        listId={listId}
        dataPPTOption={dataPPT}
      ></ModalOptionPrint>
    </div>
  );
};

export default Prepay;
